import { render, staticRenderFns } from "./RecItem.vue?vue&type=template&id=ff5908e2"
import script from "./RecItem.vue?vue&type=script&lang=js"
export * from "./RecItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports